export default __webpack_public_path__ + "static/media/02_Blauwe brug_2-nieuwe situatie.a0390653.jpg";